export default __webpack_public_path__ + "assets/images/a7dbea3a6eb833e4db6c92abcce861c1.svg";